import { ErrorType } from '../../../../models/HttpError';
import { AppState } from '../../../../redux/reducers';
import { RelationShipTypeViewModel } from '../../../../models/Entities/Person/RelationshipType/RelationshipTypeModels';

// store
import * as RelationshipTypesStore from '../../../../redux/middleware/PersonRelationshipTypes.Middleware';

export interface IProps {
  selectedRelationshipTypeId?: number | undefined;
  label?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  errorMessage?: string | undefined;
  // when informed, only the relationship types available for that kind of person are offered
  personType?: number | undefined;
  onSelectionChange: (relationshipTypeId: number | undefined) => void;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  error: ErrorType | undefined;
  relationshipTypes: RelationShipTypeViewModel[];
}

interface DispatchProps {
  GetRelationshipTypes: typeof RelationshipTypesStore.actionCreators.GetRelationshipTypes;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonRelationshipTypes?.isLoadingAll,
  isLoadingSuccessfully: state.PersonRelationshipTypes?.successLoadingAll,
  error: state.PersonRelationshipTypes?.error,
  relationshipTypes: (state.PersonRelationshipTypes?.list ?? [])
    .filter((item: RelationShipTypeViewModel) => item.isActive && !item.isDeleted)
    .sort((a: RelationShipTypeViewModel, b: RelationShipTypeViewModel) =>
      (a.name || '').localeCompare(b.name || '')
    ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...RelationshipTypesStore.actionCreators
};
